import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../shared/services/auth.service';
import { EMPTY, catchError, filter, take, timeout } from 'rxjs';

@Component({
  selector: 'app-auth-callback',
  template: ``,
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  async ngOnInit() {
    try {
      // Intenta cargar el documento de descubrimiento y loguear
      const loggedIn = await this.authService.getOAuthService().loadDiscoveryDocumentAndTryLogin();
      if (loggedIn && (await this.authService.restoreSession())) {
        // Si los tokens son válidos, redirige al dashboardo
        this.authService
          .getUserLogged()
          .pipe(
            filter(Boolean),
            take(1),
            timeout(15000),
            catchError(error => {
              console.error('Error retrieving user after login callback: ', error);
              this.authService.logout(true);
              return EMPTY;
            })
          )
          .subscribe(() => {
            const url = sessionStorage.getItem('postLoginRedirectUrl') || '/dashboard';
            sessionStorage.removeItem('postLoginRedirectUrl');
            this.router.navigateByUrl(url);
          });
      } else {
        // Si no hay tokens válidos, inicia el proceso de login
        localStorage.removeItem('user');
        console.error('Error en la autenticación o tokens inválidos');
        this.authService.login();
      }
    } catch (error) {
      console.error('Error during login callback: ', error);
      this.authService.logout(true);
    }
  }
}
